import { Dialog } from "vant";
import { miceService } from "@/service/miceService.js";
import { Indicator } from "mint-ui";
import { SmartStorage } from "smart-core-util";
import { Toast } from "mint-ui";
import getLocationPro from "@/utils/getLocation.js";
import iJsBridge from "./ijsBridge";
import photoLog from "@/components/PhotoLog/plugin.js";

export default {
  methods: {
    /**
     * 计算两个坐标点之间的距离
     * @param {Object} currentLocation - 当前位置信息 {el: 经度, nl: 纬度}
     * @param {Object|String} targetGPS - 目标位置信息，可以是对象或JSON字符串 {el: 经度, nl: 纬度}
     * @returns {Number} 返回计算出的距离（米）
     */
    calculateDistance(currentLocation, targetGPS) {
      // 定位地点
      let m1 = new AMap.Marker({
        position: new AMap.LngLat(currentLocation.el, currentLocation.nl),
      });

      // 餐厅地点
      let orderGPS;
      try {
        orderGPS = targetGPS || JSON.parse(targetGPS);
      } catch (error) {
        orderGPS = {
          el: 0,
          nl: 0,
        };
      }

      let el = Number(orderGPS.el) || 0;
      let nl = Number(orderGPS.nl) || 0;
      let m2 = new AMap.Marker({
        position: new AMap.LngLat(el, nl),
      });

      var p1 = m1.getPosition();
      var p2 = m2.getPosition();
      return Math.round(p1.distance(p2));
    },

    async getLocationFailed(onlyGetLocation) {
      return new Promise(async (resolve, reject) => {
        if (!onlyGetLocation && !this.mealRules.electricFence) {
          resolve(true);
          return;
        }
        let option = await getLocationPro();
        if (option && option.success) {
          this.imygeoLocation = {
            nl: option.nl,
            el: option.el,
            ...option,
          };
          this.imygeoLocation.distance = this.calculateDistance(
            this.imygeoLocation,
            this.orderDetail.itsItemData.gps
          );
          if (!onlyGetLocation) {
            let res = await this.checkDistance();
            if (res) {
              resolve(true);
            } else {
              resolve(false);
            }
          }
          resolve(true);
        } else {
          this.imygeoLocation = {
            success: false,
            message: option.message || "定位失败",
            nl: 0,
            el: 0,
          };
          let positionClosed = this.imygeoLocation.message == "定位失败";
          if (this.mealRules.electricFence && positionClosed) {
            let msg = "定位失败，请检查定位权限后重试";
            if (this.event.tenant_code == "roche") {
              msg =
                '定位失败，请检查定位权限后重试，如您已更换餐厅用餐，请点击"餐厅更换"，更换餐厅后重新支付。';
            }
            Dialog.alert({
              title: "提示",
              message: msg,
              confirmButtonText: "确定",
            }).then(() => {
              this.$router.push({ path: "/orderList" });
            });
            resolve(false);
            return;
          }
        }
      });
    },

    async checkDistance() {
      return new Promise((resolve, reject) => {
        let queryParams = {
          NodeCode: "Meal_CheckPosition",
          ContextDataKeys: {
            ItemId: this.orderDetail.itemId,
            EL: this.imygeoLocation.el,
            NL: this.imygeoLocation.nl,
          },
        };
        let distance = 0;
        if (this.imygeoLocation.success) {
          // 使用独立方法计算距离
          distance = this.calculateDistance(
            this.imygeoLocation,
            this.orderDetail.itsItemData.gps
          );
          queryParams.ContextDataKeys.Distance = distance;
          queryParams.ContextDataKeys.positionClosed = false;
        } else {
          queryParams.ContextDataKeys.positionClosed =
            this.imygeoLocation.message;
        }
        if (
          ["roche"].includes(this.event.tenant_code) &&
          Number(distance) > 5000
        ) {
          Dialog.confirm({
            title: "提示",
            message: "您的当前地点可能不在餐厅附近，请确认是否继续操作",
            confirmButtonText: "是",
            cancelButtonText: "否",
            showCancelButton: true,
            closeOnClickOverlay: true,
          }).then((action) => {
            if (action == "confirm") {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        } else {
          resolve(true);
        }
      });
    },
  },
};
